import { Component } from "@angular/core";

@Component({
  selector: "icon-beneficios-anos-cotizados-infografia",
  templateUrl: "./beneficios-anos-cotizados-infografia.svg",
  styles: ['svg { display: block; width: 100%; height: auto; }'],
  standalone: true,
})
export class BeneficiosAnosCotizadosInfografiaComponent {}